// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var GraphqlTag = require("graphql-tag").default;
var Js_null_undefined = require("rescript/lib/js/js_null_undefined.js");

function ReadQuery(Config) {
  var graphqlQueryAST = GraphqlTag(Config.query);
  var apolloDataToRecord = function (apolloData) {
    return Belt_Option.map((apolloData == null) ? undefined : Caml_option.some(apolloData), Config.parse);
  };
  var make = function (client, variables, param) {
    var apolloData = client.readQuery({
          query: graphqlQueryAST,
          variables: Js_null_undefined.fromOption(variables)
        });
    return Belt_Option.map((apolloData == null) ? undefined : Caml_option.some(apolloData), Config.parse);
  };
  return {
          graphqlQueryAST: graphqlQueryAST,
          apolloDataToRecord: apolloDataToRecord,
          make: make
        };
}

function WriteQuery(Config) {
  var graphqlQueryAST = GraphqlTag(Config.query);
  var make = function (client, variables, data, param) {
    client.writeQuery({
          query: graphqlQueryAST,
          variables: Js_null_undefined.fromOption(variables),
          data: data
        });
  };
  return {
          graphqlQueryAST: graphqlQueryAST,
          make: make
        };
}

exports.ReadQuery = ReadQuery;
exports.WriteQuery = WriteQuery;
/* graphql-tag Not a pure module */
